import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { EnergyAnalysisTrendChartType, EnergyAnalysisTrendSeries } from "../model/types";

import { ENERGY_ANALYSIS_TREND_CHART_TYPE } from "../model/constants";

export const buildTrendChartOption = (
  years: number[],
  series: EnergyAnalysisTrendSeries[],
  chartType: EnergyAnalysisTrendChartType
) => {
  const isLine = chartType === ENERGY_ANALYSIS_TREND_CHART_TYPE.line;
  const isPercent = chartType === ENERGY_ANALYSIS_TREND_CHART_TYPE.stackedPercent;
  const yearTotals = years.map((_, index) => series.reduce((total, item) => total + (item.data[index] ?? 0), 0));
  return {
    dataZoom: [],
    series: series.map((item) => ({
      barCategoryGap: "32%",
      barMaxWidth: 48,
      data: item.data.map((value, index) => {
        if (!isPercent) return value;
        const yearTotal = yearTotals[index] ?? 0;
        return yearTotal === 0 ? 0 : (value / yearTotal) * 100;
      }),
      itemStyle: { color: item.color },
      name: item.name,
      stack: isLine ? undefined : "total",
      tooltip: {
        valueFormatter: isPercent
          ? (value: number) => `${formatNumberBasedOnUser(value, 2)}%`
          : (value: number) => formatNumberBasedOnUser(value, 2),
      },
      type: isLine ? "line" : "bar",
    })),
    tooltip: {
      trigger: "axis",
    },
    xAxis: [
      {
        boundaryGap: !isLine,
        data: years,
        type: "category",
      },
    ],
    yAxis: [
      {
        axisLabel: {
          formatter: (value: number) =>
            `${formatNumberBasedOnUser(value, 2)}${isPercent ? "%" : ""}`,
        },
        max: isPercent ? 100 : undefined,
        scale: false,
        type: "value",
      },
    ],
  };
};
